import { createStore, applyMiddleware, compose } from "redux";
import { combineReducers } from "redux";
import createSagaMiddleware from "redux-saga";
import { connectRouter, routerMiddleware } from "connected-react-router";
import history from "./browserHistory";
import mySaga from "data/form/sagas";

// Reducers
import { app, forms } from "./data";
import formPatchMiddleware from "./middleware/formPatch";

const sagaMiddleware = createSagaMiddleware();

// Redux dev tools (browser tool)
/* istanbul ignore next */
const composeEnhancers =
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	((window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
			trace: true,
			traceLimit: 25,
		})) ||
	compose;

// Create our store
const store = createStore(
	combineReducers({
		app,
		forms,
		router: connectRouter(history),
	}),
	composeEnhancers(
		applyMiddleware(
			routerMiddleware(history),
			formPatchMiddleware,
			sagaMiddleware
		)
	)
);

sagaMiddleware.run(mySaga);

export { history };
export default store;
